module.exports = __webpack_public_path__ + "static/img/certificate4.df44c892.png";